import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { keyPressCharacters, checkAndRemoveTitleWording, keyPressTH } from 'src/app/functions/string-formatter.function';
import { RegisterParticipantRequest, CheckEmailDuplicateByNameRequest, RegisterCompanyPublicControllerService, EventInfoWithConsentResponse } from '@ent-regis/entregis-ts-angular';
import { toggleControl, decorateParticipantFormForModal, buildParticipantFormBase } from 'src/app/register-company/models/register-form.model';
import { AbstractControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { buildParticipantForm } from 'src/app/company/forms/participant-form.factory';

@Component({
  selector: 'app-company-participant-modal',
  templateUrl: './company-participant-modal.component.html',
  styleUrls: ['./company-participant-modal.component.scss']
})
export class CompanyParticipantModalComponent implements OnInit {

  @Input() participant?: FormGroup;
  @Input() noneDietaryId;
  @Input() eventInfoWithConsent: EventInfoWithConsentResponse;
  @Input() dietaries: [];
  @Input() contactCount: number;
  @Input() participantCount: number;
  @Input() maxParticipant: number;
  @Input() registerCompanyId: number;
  @Output() passData: EventEmitter<RegisterParticipantRequest> = new EventEmitter();
  submitted: boolean;
  
  countryISO = CountryISO;
  searchCountryField = SearchCountryField;
  isShowDietary = false;
  form: FormGroup; 
  
  private subscription = new Subscription();
  
  get f() { return this.form.controls; }

  get isParticipantCtrl() {
    return this.form.get('isParticipant');
  }

  get isAttendeeCtrl() {
    return this.form.get('isAttendee');
  }

  constructor(
    public bsModalRef: BsModalRef,
    private registerCompanyPublicService: RegisterCompanyPublicControllerService
  ) { }

  ngOnInit() {
    const p: RegisterParticipantRequest = this.participant instanceof FormGroup
      ? this.participant.value
      : this.participant || {};

    this.form = decorateParticipantFormForModal(
      buildParticipantForm(p, this.registerCompanyId, this.noneDietaryId),
      this.contactCount,
      this.participantCount,
      this.maxParticipant
    );
    
    this.isParticipantCtrl.valueChanges.subscribe((value: boolean) => {
      this.handleExclusiveToggle(this.isAttendeeCtrl, value);
    });

    this.isAttendeeCtrl.valueChanges.subscribe((value: boolean) => {
      this.handleExclusiveToggle(this.isParticipantCtrl, value);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private handleExclusiveToggle(otherCtrl: AbstractControl, value: boolean): void {
    if (value) {
      otherCtrl.setValue(false, { emitEvent: false });
      toggleControl(otherCtrl, true);
    } else {
      toggleControl(otherCtrl, false);
    }
  }

  checkEmailDuplicated(f: AbstractControl, complete: () => void): void {
    if (f.valid) {
      const request: CheckEmailDuplicateByNameRequest = {
        email: f.value,
        eventAlias: this.eventInfoWithConsent.eventAlias
      }
      this.registerCompanyPublicService.checkRegisterEmailDuplicateUsingPOST(request)
        .subscribe((result) => {
          if (result.data) {
            f.setErrors({ incorrect: result.data });
          } else {
            f.setErrors(null);
            if (complete) { complete(); }
          }
        });
    }
  }

  onSubmit() {
    this.submitted = true;

    if(this.form.valid) {
      this.checkEmailDuplicated(this.f.email ,() => {
        const formValue = this.form.value;
        const participant: RegisterParticipantRequest = {
          ...formValue,
          mobileNumber: formValue.mobileNumber.e164Number
        };
        this.passData.emit(participant);
        this.bsModalRef.hide();
      });
    }
  }

  onKeyPressCharacters(event: any): boolean {
   return keyPressCharacters(event);
  }

  onCheckAndRemoveWording(name: string): void {
    const value = this.form.get(`${name}`).value;
    this.form.get(`${name}`).setValue(checkAndRemoveTitleWording(value));
  }

  onKeyPressExcludeTH(event: any): boolean {
    return keyPressTH(event);
  }

}
